<style scoped lang="scss">
::v-deep .activities-row {
    .activity-card {
        @media screen and (max-width: 1279.98px) {
            width: 50% !important;
        }

        @media screen and (max-width: 575.98px) {
            width: 100% !important;
        }
    }
}

::v-deep .extras-row {
    .gift-card,
    .static-card,
    .speaker-card,
    .location-card {
        height: auto !important;
    }

    .small {
        margin-bottom: 8px !important;
    }

    img {
        transform: none !important;
    }

    .subtitle,
    .xsmall {
        display: none;
    }

    .static-card, .gift-card {
        display: block !important;
        .title {
            font-size: 1rem !important;
            font-weight: 500 !important;
            line-height: 1.5 !important;
        }

        .media-container {
            margin-bottom: 8px !important;
        }
    }

    button {
        display: none;
    }
}
</style>

<template>
    <div class="row mh-lg-100-vh align-content-start mb-40">
        <div v-if="items.activity.length == 0" class="container">
            <div class="row">
                <div class="col-12 col-lg-8 col-xxl-10 data-fixed-side mb-40 mb-md-80">
                    <div class="mb-40 d-flex flex-wrap w-100">
                        <h3 class="title">Mijn teambuildings</h3>
                    </div>
                    <no-activities-card :fixed-width="true"></no-activities-card>
                </div>
            </div>
        </div>
        <activities-row v-else :force-grid="true" :title="'Mijn teambuildings'" col="col-12 col-lg-8 col-xxl-10 data-fixed-side mb-40 mb-md-80" :activities="items.activity" :items-per-row="3" ratio="250:175" @updated="setList"></activities-row>
        <div v-if="items.speaker.length > 0 || items.location.length > 0 || items.staticItem.length > 0 || items.gift.length > 0" class="container">
            <div class="row extras-row">
                <div class="col-12 col-lg-8 col-xxl-10 data-fixed-side mb-40 mb-md-80">
                    <div class="mb-40 d-flex flex-wrap w-100">
                        <h3 class="title">Mijn extra's</h3>
                    </div>
                    <div class="row mb-n24">
                        <div class="col-12 col-sm-6 col-xl-4 mb-24" v-for="speaker in items.speaker" :key="speaker.id">
                            <speaker-card :speaker="speaker" ratio="250:175" @updated="setList"></speaker-card>
                            <div class="tag-row mt-12">
                                <div class="tag-col">
                                    <div class="tag tag-accent-light tag-xs">Spreker</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-xl-4 mb-24" v-for="location in items.location" :key="location.id">
                            <location-card :location="location" ratio="250:175" @updated="setList"></location-card>
                            <div class="tag-row mt-12">
                                <div class="tag-col">
                                    <div class="tag tag-accent-light tag-xs">Locatie</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-xl-4 mb-24" v-for="(staticItem, index) in items.staticItem" :key="index">
                            <static-card class="w-100 h-100" :staticItem="staticItem" :pages="pages" ratio="250:175" @updated="setList"></static-card>
                            <div class="tag-row mt-12">
                                <div class="tag-col">
                                    <div class="tag tag-accent-light tag-xs">Extra</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-xl-4 mb-24" v-for="gift in items.gift" :key="gift.id">
                            <gift-card class="w-100 h-100" :gift="gift" :pages="pages" ratio="250:175" @updated="setList"></gift-card>
                            <div class="tag-row mt-12">
                                <div class="tag-col">
                                    <div class="tag tag-accent-light tag-xs">Gift</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <floating-side-wrapper class="order-list">
            <div class="p-56 text-white bg-dark">
                <h3 class="mb-16" v-html="copyConfig.order.title"></h3>
                <p class="mb-16 font-weight-light text-cut" v-html="copyConfig.order.description"></p>
                <div class="btn btn-accent btn-white-hover" @click="showCreateOrder" v-html="copyConfig.order.cta"></div>
            </div>
            <div class="p-56">
                <h3 class="mb-16" v-html="copyConfig.contact.title"></h3>
                <p class="mb-16 font-weight-light" v-html="copyConfig.contact.description"></p>
                <a :href="copyConfig.contact.cta_link" class="btn btn-accent" v-html="copyConfig.contact.cta"></a>
            </div>
        </floating-side-wrapper>
    </div>
</template>
<script>
import canCreateOrder from "../mixins/can-create-order";
import canReadList from "../mixins/can-read-my-list";

export default {
    mixins: [canCreateOrder, canReadList],

    props: {
        pages: {
            type: Array,
            required: false,
            default: null
        },
    },

    
}
</script>